import { p as proxyCustomElement, H, h } from './p-Nx975UkZ.js';
import { d as defineCustomElement$2 } from './p-DpjceM40.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.9.0
 */

const PageHeader = /*@__PURE__*/ proxyCustomElement(class PageHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Indicates whether the page header is inactive or not.
         * When set to true, the page header is visually inactive
         * @prop {boolean} inactive - Controls the inactive state of the page. Defaults to false.
         */
        this.inactive = false;
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        var _a, _b;
        const hasNavigationSlot = !!this.el.querySelector("[slot='navigation']");
        const hasMultiActions = ((_b = (_a = this.el.querySelector("[slot='actions']")) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length) > 1;
        return (h("header", { key: '10bfda3d0c68890a44aa7de1a1d0a59f595df29d', class: {
                "tds-page-header": true,
                "has-multi-actions": hasMultiActions,
                "has-nav": hasNavigationSlot,
                "tds-page-header--profile": this.profile,
                inactive: this.inactive,
            } }, h("div", { key: '8e81988162dc5ecd54e02604a064ce7b92c28c86', class: "tds-page-header__title-bar" }, h("div", { key: '23fd5f73c5692f57e66ecb8d8504c614615be86f', class: "tds-page-header__primary" }, h("slot", { key: '0845504bf47cdc419a8dbd959371ccef108faabd' })), h("slot", { key: 'e95984c4a6a2c97594530de7bba3f9ac2777d3aa', name: "actions" })), hasNavigationSlot && (h("tds-page-header-nav", { key: 'ee294454e1c9649842030d3f43c95d38257e2594', class: "tds-no-print" }, h("slot", { key: 'a03b7c80dcedec402f2069d9de1a492f17bf9466', name: "navigation" })))));
    }
    get el() { return this; }
}, [4, "tds-page-header", {
        "inactive": [4],
        "profile": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-page-header", "tds-page-header-nav"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-page-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PageHeader);
            }
            break;
        case "tds-page-header-nav":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-page-header.js.map
